export const texts = {
  ADD_HOLD_BUTTON_TEXT: "Add hold",
  CUSTOMERS_ON_HOLD_TITLE: "Customers on hold",
  HOLD_BUTTON_TEXT: "Hold",
  FORM_TITLE: "Put customer on hold",
  HOLD_EXISTS_TOOLTIP: "This hold already exists",
  ALL_FIELDS_SHOULD_BE_FILLED_TOOLTIP: "All fields should be filled",
  HOLD_REMOVED_SUCCESSFULLY: "Hold removed successfully",
};
